/* Product-page-only cleanup, including reviews loaded by pagination or sorting. */
(() => {
  function start() {
    const product = document.querySelector('#judgeme_product_reviews')?.closest('.product');
    if (!product) return;
    function clean() {
      const widget = product.querySelector('#judgeme_product_reviews');
      if (!widget) return;
      const actions = widget.querySelector('.jdgm-widget-actions-wrapper');
      const questionForm = widget.querySelector('.jdgm-question-form-wrapper');
      if (actions && questionForm && questionForm.parentElement !== actions) {
        actions.appendChild(questionForm);
      }
      if (questionForm) {
        const notice = questionForm.previousElementSibling;
        if (notice?.classList.contains('jdgm-notification') && !notice.classList.contains('pdp-question-notice')) {
          notice.classList.add('pdp-question-notice');
          notice.setAttribute('role', 'status');
          // Wait for the native form's closing animation before revealing confirmation.
          window.setTimeout(() => {
            if (!notice.isConnected) return;
            const offset = document.querySelector('header')?.getBoundingClientRect().height || 0;
            const rect = notice.getBoundingClientRect();
            if (rect.top < offset + 16 || rect.bottom > window.innerHeight - 40) {
              window.scrollTo({ top: window.scrollY + rect.top - offset - 16, behavior: 'instant' });
            }
          }, 450);
        }
      }
      widget.querySelectorAll('.jdgm-rev-widg__summary-text a').forEach(link => {
        const text = document.createElement('span');
        text.textContent = link.textContent;
        link.replaceWith(text);
      });
      widget.querySelectorAll('.jdgm-rev__reply').forEach(reply => {
        reply.classList.toggle('pdp-empty-reply', !reply.textContent.trim());
      });
      widget.querySelectorAll('.jdgm-rev__replier-wrapper').forEach(heading => {
        const first = heading.firstChild;
        if (first && first.nodeType === Node.TEXT_NODE && /^\s*>>/.test(first.textContent)) {
          first.textContent = first.textContent.replace(/^\s*>>\s*/, '');
        }
      });
    }
    document.addEventListener('click', event => {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;
      const widget = product.querySelector('#judgeme_product_reviews');
      const ask = target.closest('.jdgm-ask-question-btn');
      if (ask && widget && window.jdgm?._setupQuestionsForm &&
          !widget.querySelector('.jdgm-question-form-wrapper')) {
        // Reattach the native form after the theme has rendered the widget.
        // Its own handlers retain validation, consent and submission behavior.
        window.jdgm._setupQuestionsForm(window.jdgm.$(widget));
      }
      const rating = target.closest('.pdp-rating-summary');
      if (rating && widget) {
        const title = widget.querySelector('.jdgm-rev-widg__title');
        if (!title) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        const header = document.querySelector('header');
        const offset = header ? header.getBoundingClientRect().height : 0;
        window.scrollTo({
          top: window.scrollY + title.getBoundingClientRect().top - offset - 16,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
        return;
      }
      if (!widget || !widget.contains(target) || !window.jdgm?.$) return;
      // Judge.me checks this flag before its native tab-loading scroll.
      // Keep its existing tab handlers and asynchronous question fetching.
      const tab = target.closest('.jdgm-subtab__name');
      if (tab) window.jdgm.$(widget).data('not-scroll-to', true);
      else if (target.closest('.jdgm-paginate, .jdgm-histogram, .jdgm-sort-dropdown, .jdgm-review-search')) {
        window.jdgm.$(widget).removeData('not-scroll-to');
      }
    }, true);
    clean();
    // Child/text changes cover asynchronous setup and page replacement; no attribute loop.
    new MutationObserver(clean).observe(product, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

